// extracted by mini-css-extract-plugin
export default {"inputSearch":"SearchInput_inputSearch__K9klO","searchIcon":"SearchInput_searchIcon__aLDSA"};